// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Report Mapping'">
    <button class="btn btn-primary"
              command-access="UpdateDynamicReport"
              type="button"
              ng-click="\$ctrl.addNew()">
        Add new
      </button>
    </sub-header>

  <table class="table table--generate-row-ids table--last-column-to-right" ng-if="\$ctrl.reports.length !== 0">
    <thead>
      <tr>
        <th>No</th>
        <th>Name</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody class="tbody">
      <tr ng-repeat="report in \$ctrl.reports">
        <td></td>
        <td>{{report.name}}</td>
        <td class="table__actions">
          <button class="btn btn-warning"
                  ng-click="\$ctrl.edit(report)"
                  command-access="UpdateDynamicReport"
                  type="button"
          >
            Edit
          </button>
          <button class="btn btn-danger"
                  ng-click="\$ctrl.delete(report)"
                  command-access="UpdateDynamicReport"
                  type="button">
            Delete
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/dynamic-report/dynamic-report-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;